import { Injectable, inject } from '@angular/core';
import { ATTACHMENTS_HANDLER_CONFIG } from '../config/attachments-handler.config';
import { UploadHistoryStore } from './upload-history.store';

@Injectable({
  providedIn: 'root',
})
export class NavigationGuardService {
  private readonly uploadHistory = inject(UploadHistoryStore);
  private registered = false;

  readonly isUploading = this.uploadHistory.isUploading;

  private readonly beforeUnloadHandler = (e: BeforeUnloadEvent) => {
    if (!this.isUploading()) return;
    e.preventDefault();
  };

  register(): void {
    if (this.registered) return;
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
    this.registered = true;
  }

  unregister(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    this.registered = false;
  }
}
